<template>
  <a :href="item.link">
    <div class="wp-block-columns immolisting__header">
        <div class="wp-block-column">
            <span class="fal fa-home"></span>
            {{ item.category }}
        </div>

        <div class="wp-block-column">
            <span v-html="item.price"></span>
        </div>
    </div>

    <div class="immolisting__image"
        :style="{backgroundImage: 'url(' + item.image + ')'}"></div>

    <div class="immolisting__content">
      <p class="h3"><span class="text-truncate d-block">{{ item.title }}</span>
        <small>In {{ item.zip }} {{ item.city }}</small></p>

      <div v-html="item.iconfields"></div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Expose',

  props: [
    "item"
  ]
};
</script>
